import { useMsal } from "@azure/msal-react"
import { Button } from "@mui/material"
import Stack from "@mui/material/Stack"
import { usePathname, useRouter } from "next/navigation"
import { FC } from "react"

// import { Button } from "src/components/common/button"
import { Icon } from "src/components/common/icon"
import { create } from "src/helpers/bem"

import { getPath } from "src/helpers/paths"
import { resetStates } from "src/helpers/resetStates"
import { useTranslation } from "src/hooks/translation"

import { useLocale } from "src/states/locale"

import { addNotification } from "src/states/notifications"

import styles from "./AccountNavigation.module.scss"

const bem = create(styles, "AccountNavigation")

export const AccountNavigation: FC = () => {
  const { messages: translations } = useTranslation()
  const locale = useLocale()
  const pathname = usePathname()
  const router = useRouter()
  const { instance } = useMsal()

  const navigationTranslations = translations.pages.account.overview.navigation
  const buttons: {
    title: string
    url: string
    selected: boolean
    icon: "profile" | "bookings" | "orders" | "service"
  }[] = [
    {
      title: navigationTranslations.profile,
      url: getPath(locale, "account"),
      selected: pathname === getPath(locale, "account"),
      icon: "profile",
    },
    {
      title: navigationTranslations.bookings,
      url: getPath(locale, "bookings"),
      selected: pathname === getPath(locale, "bookings"),
      icon: "bookings",
    },
    {
      title: navigationTranslations.service,
      url: getPath(locale, "orders"),
      selected: pathname === getPath(locale, "orders"),
      icon: "orders",
    },
    {
      title: navigationTranslations.support,
      url: getPath(locale, "service"),
      selected: pathname === getPath(locale, "service"),
      icon: "service",
    },
  ]

  const handleLogout = async () => {
    instance
      .logoutRedirect({
        postLogoutRedirectUri: "/",
      })
      .catch((e) => {
        addNotification({
          variant: "error",
        })
      })
    await resetStates()
  }

  return (
    <Stack className={bem("navigation")} direction={"column"}>
      {buttons.map((button) => {
        return (
          <Button
            key={button.title}
            variant="outlined"
            className={
              button.selected
                ? bem("navigation__button__selected")
                : bem("navigation__button")
            }
            startIcon={
              <Icon
                name={button.icon}
                className={
                  button.selected
                    ? bem("navigation__icon__selected")
                    : bem("navigation__icon")
                }
              />
            }
            onClick={() => {
              router.push(button.url)
            }}
          >
            {button.title}
          </Button>
        )
      })}
      <Button
        key={navigationTranslations.logout}
        className={bem("navigation__button__logout")}
        startIcon={<Icon className={bem("navigation__icon")} name={"logout"} />}
        variant="outlined"
        onClick={handleLogout}
      >
        {navigationTranslations.logout}
      </Button>
    </Stack>
  )
}
